import { CustomRow } from '../enums';
import { ProcessEnvMap } from '../interfaces';

export const projectCategoryModifier: ProcessEnvMap = {
  Primary: CustomRow.Primary,
  Secondary: CustomRow.Secondary,
};

export const leasingEquipmentModifier: ProcessEnvMap = {
  Red: CustomRow.Red,
  Orange: CustomRow.Orange,
  Secondary: CustomRow.Secondary,
};
